import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { applicationRouteConstants } from '../shared/_constants';

const PrivateRoute = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = useSelector(
    (state) => state.AuthReducer.isAuthenticated
  );

  // Check both location state and Redux state
  const isAuth = location.state?.isAuthenticated || isAuthenticated;

  if (!isAuth) {
    return <Navigate to={applicationRouteConstants.DEFAULT} replace />;
  }

  return children;
};

export default PrivateRoute;
